import { IconCloudUpload, IconDownload, IconFileSpreadsheet, IconLoader2 } from '@tabler/icons-react'
import { useState } from 'react'
import { MonthCode } from 'src/API/rest.forecast_regionwise'
import { useStatesAPI } from 'src/API/rest.states'
import { ButtonIconSquare } from 'src/components/buttons'
import { FileInputDragDropStandard } from 'src/components/standard.fileDroper'
import { InputStandard } from 'src/components/standard.input'
import { SelectStandard } from 'src/components/standard.select'
import { TypographyH2 } from 'src/components/typography'
import { RefMonthComponent } from './component.refMonth'
import { useGetLatestCalendarDate } from 'src/API/rest.forecast_calender'
import { ErrorBoxStandard } from 'src/components/standard.errorbox'
import { useRestAPI } from 'src/API/axiosAPI'
import { useStylewiseForcast } from 'src/API/rest.stylewiseForcast'
import { ProgressFullScreen } from 'src/components/progressLoading'
import { toast } from 'src/shadcn/ui/use-toast'
import { Input } from 'src/shadcn/ui/input'
import { format, parse } from 'date-fns'
import { ModalValidationError } from './component.validationErrorModal'
import { useForecastAPI } from 'src/API/rest.forecast'
import { useDownloadFile } from 'src/API/rest.downloadFile'


type MonthType = {
    month: string;
    value: string;
}
type InvalidData = {
    invalid_style_name: string[];
    invalid_channel_name: string[];
}
export default function ForcastStyleWise() {
    const [isOpen, setIsOpen] = useState(false)

    const [stateSelected, setStateSelected] = useState<number | null>(null)
    const [seletedFile, setSelectedFile] = useState<File | null>(null)
    const api = useRestAPI()
    const [validationErrors, setValidationErrors] = useState<InvalidData | null>(

        null
    )

    const {
        downloadTemplateStylewise,
        isDownloadTemplateError,
        isDownloadingTEmplateStyleswise,
        isvalidateingstylewiseExel,
        isvalidatestylewiseExelError,
        validatestylewiseExel,
        validateProgress,
        uploadstylewiseExel,
        isuploadingstylewiseExel,
        uploadProgress
    } = useStylewiseForcast({})


    const {
        isErrorlatestCalendarDate,
        isFetchedlatestCalendarDate,
        isFetchinglatestCalendarDate,
        isLoadinglatestCalendarDate,
        latestCalendarDate,
        refetchlatestCalendarDate
    } = useGetLatestCalendarDate({
        trigger: true
    })

    const {
        states,
        isLoading: isLoadingState,
        isError: isErrorState,
        isFetching: isFetchingState
    } = useStatesAPI({
        trigger: true
    });

    const {
        forecastData,
        isFetchingForcastData,
        isErrorforcast,
        refetchForcastData
    } = useForecastAPI({
        FT02_Date: latestCalendarDate?.date || '',
        FT02_ForecastLevel: 'NPStyleWise',
        FT02_M04_StateID: stateSelected,
        trigger: stateSelected?true:false
    })

    const {
        downoadFile
    } = useDownloadFile()


    console.log(validateProgress)


    if (isErrorlatestCalendarDate && !isFetchinglatestCalendarDate) {
        return (
            <div className=' grow flex flex-col items-center '>
                <ErrorBoxStandard
                    onRetry={refetchlatestCalendarDate}
                />
            </div>
        )
    }

    return (
        <div className=' grow  flex flex-col overflow-auto items-center '>

            <ProgressFullScreen
                progress={validateProgress}
                show={isvalidateingstylewiseExel}
                subTitle='Validating file...'
            />
            <ProgressFullScreen
                progress={uploadProgress}
                show={isuploadingstylewiseExel}
                subTitle='uploading file...'
            />



            {/* Ref Month
            <RefMonthComponent
                forecastMonth={latestCalendarDate?.date || ''}
                isFetchingLatestForecastCalender={isFetchinglatestCalendarDate}
            /> */}
            <div className='  text-center flex text-vstargray-800 dark:text-vstargray-100 py-2'>Download Template {isDownloadingTEmplateStyleswise ? <IconLoader2 size={10} className=' inline animate-spin' /> : <span onClick={() => downloadTemplateStylewise()} className=' underline text-blue-500 cursor-pointer hover:text-blue-700'>here</span>}</div>

            {/* NP style wise */}
            <div className=' grow flex flex-col overflow-hidden bg-white dark:bg-vstargray-900  rounded-md w-full text-center'>
                <div className=' grow flex flex-col overflow-auto p-3 '>
                    <TypographyH2>NP Style wise</TypographyH2>
                    <div className=' flex gap-2 '>
                        {/* <InputStandard
                            title='Date'
                            placeholder='Date'
                            type='date'
                            disabled
                            value={latestCalendarDate?.date || ''}
                        /> */}
                        <InputStandard
                            title='Date'
                            type='month'
                            className='w-min'
                            value={latestCalendarDate?.date ? format(parse(latestCalendarDate?.date, 'yyyy-mm-dd', new Date()), 'yyyy-mm') : ''}
                            disabled
                        />
                        <SelectStandard
                            title='State'
                            onChange={(e) => setStateSelected(Number(e.target.value))}
                            value={stateSelected ? String(stateSelected) : ''}
                            placeHolder='Select State'
                            options={states?.map(state => ({ value: String(state.FM04_StateID), label: state.FM04_StateName })) || []}
                        />
                        <ModalValidationError
                            invalidData={validationErrors || null}
                            show={isOpen}
                            setShow={setIsOpen}
                        />
                    </div>
                    <div className=' grow flex items-center  w-min mx-auto mt-8'>
                        <FileInputDragDropStandard
                            disabled={stateSelected === null || !latestCalendarDate?.date ? true : false}
                            onDrop={async (file) => {
                                const fileName = file?.name?.split('.xlsx').slice(0, 1)?.join('.') || ''
                                const stateName = states?.find(emp => emp.FM04_StateID === stateSelected)?.FM04_StateName
                                if (fileName != stateName) {
                                    toast({
                                        description: 'File name not match with state name',
                                        title: 'Error'
                                    })
                                    return
                                }
                                const response = await validatestylewiseExel({
                                    file: file!
                                })
                                if (response.success === false) {
                                    console.log(response)
                                    toast({
                                        description: response.message
                                    })
                                    setValidationErrors((response as any).errors || null)
                                    if ((response as any).errors)
                                        setIsOpen(true)
                                } else {
                                    setSelectedFile(file);
                                }
                            }}
                            file={seletedFile}
                            onClear={() => setSelectedFile(null)}
                            accept={{ 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] }}
                        />
                    </div>
                    <ButtonIconSquare
                        disabled={seletedFile === null}
                        className=' mx-auto mb-5'
                        icon={isuploadingstylewiseExel ? <IconLoader2 className='animate-spin' /> : <IconCloudUpload />}
                        onClick={async () => {
                            const response = await uploadstylewiseExel({
                                date: latestCalendarDate?.date!,
                                file: seletedFile!,
                                state: stateSelected!
                            })
                            if (response.success === false) {
                                toast({
                                    title: 'Error',
                                    description: response.message
                                })
                            } else {
                                toast({
                                    title: 'Success',
                                    description: response.message
                                })
                                setSelectedFile(null)
                                refetchForcastData()
                            }
                        }}
                        variant='secondary' text='Submit' />
                    <div className=' fixed bottom-6 right-3'>
                        <ButtonIconSquare
                            
                            icon={isFetchingForcastData ? <IconLoader2 className='animate-spin' /> : <IconFileSpreadsheet />}
                            onClick={async () => {
                                if(stateSelected === null || !latestCalendarDate?.date){
                                    toast({
                                        title: 'Error',
                                        description: 'Please select state and date'
                                    })
                                    return
                                }
                                const fileName = forecastData?.ForecastHeader?.[0]?.FT01_ForecastFileName
                                if(fileName){
                                    try {
                                        await downoadFile(`${process.env.REACT_APP_BACKEND_URL_ONLY}/${fileName}`,'stylewise_forecast.xlsx')
                                    } catch (error) {
                                        toast({
                                            title: 'Error',
                                            description: 'File not found'
                                        })
                                    }

                                }else{
                                    toast({
                                        title: 'Error',
                                        description: 'File not found'
                                    })
                                }

                            }}
                            variant='white' text='Download' />
                    </div>
                </div>
            </div>

        </div>
    )
}

